<template>
  <collapsible
    class="alert alert-dark mb-5"
    :transitionDuration="'500ms'"
    :isOpen="false"
    :transitionTimingFunction="'ease-in-out'"
    :openLabel="'Nyitva'"
  >
    <div slot="trigger">
      <div class="row">
        <div class="text-white col-sm-8">
          <u>
            Részletek Elrejtése
          </u>
        </div>
        <b class="col-sm-4">
          <div class="arrow-up"></div>
        </b>
      </div>
    </div>
    <div slot="closedTrigger">
      <div class="row">
        <div class="text-white col-sm-8">
          <u>
            Részletek
          </u>
        </div>
        <b class="col-sm-4">
          <div class="arrow-down" role="button" title="Részletek lenyitása"></div>
        </b>
      </div>
      <div class="col-md-8">
        <div class="form-group row mb-2">
          <label class="col-sm-6 fw-bold">A biztosítás éves alapdíja:</label>
          <div class="col-sm-6">
            <input
              type="text"
              class="form-control"
              disabled
              :value="$store.state.chooseableAccesories.accessorySumPrice | currency"
            />
          </div>
        </div>

        <div class="form-group row mb-2">
          <label class="col-sm-6 fw-bold">A biztosítás éves díja összesen:</label>
          <div class="col-sm-6">
            <input
              type="text"
              class="form-control"
              disabled
              :value="$store.state.kieg_emelt_eves_dij | currency"
            />
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- <h1 class="h2 text-white">
        Az ön által megadott adatok alapján biztosítása az alábbi összegeket tartalmazza:
      </h1> -->
      <div class="customTrigger">
        <div>
          <div class="row">
            <div class="col-md-8">
              <div class="form-group row mb-2">
                <label class="col-sm-6">Főépület:</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="
                      $store.state.generalInfo.contractFor !== 3
                        ? $store.state.insuranceProperty.chosenInsurancePrice
                        : 0 | currency
                    "
                  />
                </div>
              </div>
              <div
                class="form-group row mb-4"
                v-if="
                  $store.state.insuranceSideBuildings.list.length > 0 &&
                    $store.state.generalInfo.contractFor !== 3
                "
              >
                <label class="col-sm-6">Melléképület(ek):</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="$store.state.insuranceSideBuildings.chosenInsurancePrice | currency"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row mb-2">
                <label class="col-sm-6">Főépület ingóság:</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="
                      $store.state.generalInfo.contractFor !== 2
                        ? mainPropertyInsurance
                        : 0 | currency
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8">
              <div class="form-group row mb-2">
                <label class="col-sm-6 fw-bold">A biztosítás éves alapdíja:</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="$store.state.chooseableAccesories.accessorySumPrice | currency"
                  />
                </div>
              </div>
              <div class="form-group row mb-2" v-if="$store.state.page > 2">
                <label class="col-sm-6 fw-bold">A kiegészítők díja összesen:</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="$store.state.eves_dij_plus | currency"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3" v-if="$store.state.page >= 3">
            <div class="col-md-8">
              <div class="form-group row mb-2">
                <label class="col-sm-6 fw-bold text-sm-end">Pótdíjak:</label>
              </div>
              <div class="form-group row mb-2" v-if="$store.state.engedmenyek.csekk">
                <label class="col-sm-6 text-sm-end">Postai csekk:</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="$store.state.engedmenyek.csekk | currency"
                  />
                </div>
              </div>
              <div class="form-group row mb-2" v-if="$store.state.engedmenyek.havi">
                <label class="col-sm-6 text-sm-end">Havi díjfizetési gyakoriság:</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="$store.state.engedmenyek.havi | currency"
                  />
                </div>
              </div>

              <div class="form-group row mb-2">
                <label class="col-sm-6 fw-bold text-sm-end">Kedvezmények:</label>
              </div>
              <div class="form-group row mb-2">
                <label class="col-sm-6 text-sm-end">Elektronikus kommunikáció:</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="$store.state.engedmenyek.elektronikus_kommunikacio | currency"
                  />
                </div>
              </div>
              <div class="form-group row mb-2">
                <label class="col-sm-6 text-sm-end">Elektronikus kárrendezés:</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="$store.state.engedmenyek.elektronikus_karrendezes | currency"
                  />
                </div>
              </div>
              <div
                class="form-group row mb-2"
                v-if="$store.state.engedmenyek.fizetesi_mod_kedvezmeny"
              >
                <label class="col-sm-6 text-sm-end">Fizetési mód:</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="$store.state.engedmenyek.fizetesi_mod_kedvezmeny | currency"
                  />
                </div>
              </div>
              <div
                class="form-group row mb-2"
                v-if="$store.state.engedmenyek.dijfizetes_gyakorisag_kedvezmeny"
              >
                <label class="col-sm-6 text-sm-end">Díjfizetési gyakoriság:</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="$store.state.engedmenyek.dijfizetes_gyakorisag_kedvezmeny | currency"
                  />
                </div>
              </div>
              <div class="form-group row mb-2" v-if="$store.state.engedmenyek.eletkor_kedvezmeny">
                <label class="col-sm-6 text-sm-end">Életkor kedvezmény:</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="$store.state.engedmenyek.eletkor_kedvezmeny | currency"
                  />
                </div>
              </div>
              <div class="form-group row mb-2" v-if="$store.state.engedmenyek.kedvezmenykod">
                <label class="col-sm-6 text-sm-end">Kedvezmény:</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="$store.state.engedmenyek.kedvezmenykod | currency"
                  />
                </div>
              </div>

              <div class="form-group row mb-2">
                <label class="col-sm-6 fw-bold">A biztosítás éves díja összesen:</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="$store.state.kieg_emelt_eves_dij | currency"
                  />
                </div>
              </div>
              <div class="form-group row mb-2">
                <label class="col-sm-6 fw-bold"
                  >Az Ön által választott díjfizetési gyakoriság szerinti díj:</label
                >
                <div class="col-sm-6">
                  <input type="text" class="form-control dark-border" disabled :value="paymentFrequentString" />
                </div>
              </div>
            </div>
          </div>
          <small>
            A biztosítás éves alapdíja a következő lépésekben megadott adatok alapján módosulhat a
            pótdíjak és/vagy kedvezmények mértékével. A biztosítás éves díja minimum 8.000 Ft lehet.
          </small>
          <div class="row">
            <div class="col-sm-6">
              <save-link-button></save-link-button>
            </div>
            <div class="col-sm-6">
              <recalculate-button v-if="$store.state.page > 1"></recalculate-button>
              <dm-button v-if="$store.state.dm" :showFromPage="4"></dm-button>
              <request-pdf-buton v-else :showFromPage="4"></request-pdf-buton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </collapsible>
</template>

<script>
import {parse as parseMoney} from 'vue-currency-input';
import RecalculateButton from './components/components/RecalculateButton.vue';
import RequestPdfButon from './components/components/RequestPdfButton.vue';
import DmButton from './components/components/DmButton.vue';
import Collapsible from './components/components/Collapsible.vue';
import SaveLinkButton from './components/components/SaveLinkButton.vue';
import 'animate.css';

export default {
  components: {
    RequestPdfButon,
    DmButton,
    Collapsible,
    SaveLinkButton,
    RecalculateButton,
  },

  data() {
    return {
      summaryPrice: 0,
      isCollapsed: false,
    };
  },
  computed: {
    mainPropertyInsurance() {
      const acceptInsurance = this.$store.state.insurancePersonalGoods.acceptCalculatedInsurance;

      if (acceptInsurance) return this.$store.state.insurancePersonalGoods.calculatedInsurancePrice;

      return this.$store.state.insurancePersonalGoods.allGoodsPrice;
    },
    paymentFrequentString() {
      const frequency = this.$store.state.paymentOptions.frequency;
      let stringFrequency;
      if (frequency == 'eves') stringFrequency = ' /év';
      else if (frequency == 'feleves') stringFrequency = ' /félév';
      else if (frequency == 'negyedeves') stringFrequency = ' /negyedév';
      else stringFrequency = ' /hó';
      return (
        this.$options.filters.currency(this.$store.state.gyakorisag_szerint_fizetendo_dij) +
        stringFrequency
      );
    },
    ClamIdentifie() {
      return this.$store.state.code;
    },
  },
  methods: {
    calculateSummaryPrice(data) {
      let price = 0;
      for (const [key, value] of Object.entries(data)) {
        if (typeof value === 'string') {
          const parsedInt = parseMoney(value, window.currencyInputOptions);
          if (parsedInt) price += parsedInt;
        }
      }
      this.summaryPrice = price;
    },
    generateClaimIdentifier(code) {
      this.$store.commit('setClaimIdentifier', code);
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 768px) {
  .claim-identifier {
    max-width: max-content !important;
  }
}
$red: #e4002b;
.arrow-up {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  float: right;
  border-bottom: 20px solid white;
  // margin-left: 80%;
  margin-bottom: 5%;
  //display: inline-block;
  cursor: pointer;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  float: right;
  border-top: 20px solid white;
  //margin-left: 80%;
  margin-bottom: 5%;
  //display: inline-block;
  cursor: pointer;
}

b {
  float: right;
}
</style>
